import cn from 'classnames';
import { find } from 'lodash';
import Link from 'next/link';
import React from 'react';
import { SegmentFilterDisplayInfo } from 'shared/SegmentFilterUtils';
import { CuisineCategoryFragment } from 'utils/gqlReactTypings.generated.d';

interface IProps {
  className?: string;
  href: string;
  item: CuisineCategoryFragment;
  active?: boolean;
}

export const CuisineCategoryButton: React.FC<IProps> = ({ className, href, item, active }) => {
  const primaryAncestor = find(item.ancestorCuisines, 'isPrimary');
  const filterDisplayInfo =
    SegmentFilterDisplayInfo[item.id] ??
    (primaryAncestor && SegmentFilterDisplayInfo[primaryAncestor.id]) ??
    SegmentFilterDisplayInfo.ALL;

  return (
    <Link
      href={href}
      className={cn(
        className,
        `flex min-h-[120px] min-w-[120px] cursor-pointer flex-col items-center justify-center rounded-md bg-white`,
        { 'border border-radish-300 shadow-[0_0_14px_rgba(0,0,0,0.1)]': active }
      )}>
      <img
        className='w-20'
        width={80}
        height={80}
        src={active ? filterDisplayInfo.hoverIcon : filterDisplayInfo.icon}
        alt={item.title}
      />
      <span className='text-xs font-medium text-neutral-700'>{item.title}</span>
    </Link>
  );
};
